var _defs, _g, _path, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "right",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 54,
    height: 54,
    fill: "#eceff4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_7_3",
    "data-name": "Component 7 \\u2013 3",
    transform: "translate(0 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    fill: "none",
    stroke: "#b0bed0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H59a0,0,0,0,1,0,0V75a0,0,0,0,1,0,0H18A18,18,0,0,1,0,57V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1H57a1,1,0,0,1,1,1V73a1,1,0,0,1-1,1H18A17,17,0,0,1,1,57V2A1,1,0,0,1,2,1Z",
    fill: "none"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    d: "M0,0H52a0,0,0,0,1,0,0V52a0,0,0,0,1,0,0H16A16,16,0,0,1,0,36V0A0,0,0,0,1,0,0Z",
    transform: "translate(2)",
    fill: "#eceff4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    transform: "translate(7)",
    fill: "#fff",
    stroke: "#b0bed0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H31A16,16,0,0,1,47,16V47a0,0,0,0,1,0,0H16A16,16,0,0,1,0,31V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1H31A15,15,0,0,1,46,16V45a1,1,0,0,1-1,1H16A15,15,0,0,1,1,31V2A1,1,0,0,1,2,1Z",
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(24 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M4.5,0,9,8H0Z",
    transform: "translate(13 3) rotate(90)",
    fill: "#5b6c97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M3,2.232,0,0V15l3-1.833Z",
    fill: "#5b6c97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.47df703730d8c2363d810771a42c5830.svg";
export { ForwardRef as ReactComponent };